import React from 'react';
import { CheckIcon, XIcon, CheckCircleIcon, GiftIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { TestimonialSection } from './TestimonialSection';
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/45913855623356:1';
const handleImageClick = () => {
  window.open(CHECKOUT_URL, '_blank');
};
export function SalesPage() {
  return <div className="w-full bg-white" data-id="element-13">
      {/* Spacer for fixed header */}
      <div className="h-10" data-id="element-14" />

      {/* SECTION 2 - HERO (dark bg) */}
      <section className="py-4 md:py-5 px-4 bg-gray-900" data-id="element-15">
        <div className="max-w-3xl mx-auto text-center" data-id="element-16">
          <span className="inline-block bg-yellow-500/20 text-yellow-300 text-sm font-semibold px-4 py-1.5 rounded-full mb-1" data-id="element-17">
            🦺 Para docentes de Seguridad e Higiene
          </span>
          <p className="text-gray-400 uppercase tracking-wider text-sm font-semibold mb-0.5" data-id="element-18">
            MANUAL ACADÉMICO
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-tight mb-10" data-id="element-19">
            SEGURIDAD E HIGIENE PARA DOCENTES
          </h1>

          {/* Main Product Image */}
          <img src="https://cdn.magicpatterns.com/uploads/o9F88z8R5M2j9xLTyuMtoS/MOCKUP_PRINCIPAL.png" alt="Manual Académico Seguridad e Higiene para Docentes" className="w-full max-w-lg mx-auto -my-6 mb-8" data-id="element-20" />

          <p className="text-xl md:text-2xl text-gray-200 font-medium mb-1" data-id="element-21">
            Todo el sistema académico listo para enseñar, evaluar y organizar el
            año completo sin empezar desde cero.
          </p>
          <p className="text-lg text-gray-400 mb-3" data-id="element-22">
            Programas listos, clases estructuradas, casos profesionales
            preparados y evaluaciones organizadas en un solo sistema. Dejá de
            perder semanas armando material y empezá el ciclo lectivo con todo
            resuelto desde el primer día.
          </p>

          <CTAButton data-id="element-23">👉 SÍ, QUIERO ACCEDER AHORA</CTAButton>
        </div>
      </section>

      {/* SECTION 3 - PAIN POINT */}
      <section className="py-6 px-4 bg-gray-50" data-id="element-24">
        <div className="max-w-3xl mx-auto text-center" data-id="element-25">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-26">
            Si enseñás Seguridad e Higiene, dejame hacerte una pregunta honesta
          </h2>
          <p className="text-xl md:text-2xl text-gray-800 font-medium mb-2" data-id="element-27">
            ¿Te pasa que el inicio del ciclo lectivo te exige más trabajo
            organizando material que dando clases?
          </p>
          <p className="text-gray-600 mb-0.5" data-id="element-28">No porque no sepas enseñar.</p>
          <p className="text-gray-600 mb-2" data-id="element-29">No porque te falte experiencia.</p>
          <p className="text-lg text-gray-800 font-medium mb-2" data-id="element-30">
            Sino porque cada año volvés a lo mismo:
          </p>
          <ul className="text-left max-w-md mx-auto space-y-1.5 mb-3" data-id="element-31">
            <li className="flex items-start gap-3" data-id="element-32">
              <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-33" />
              <span className="text-gray-700" data-id="element-34">Armar el programa anual</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-35">
              <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-36" />
              <span className="text-gray-700" data-id="element-37">
                Preparar evaluaciones desde cero
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-38">
              <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-39" />
              <span className="text-gray-700" data-id="element-40">
                Buscar casos prácticos nuevos
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-41">
              <XIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-42" />
              <span className="text-gray-700" data-id="element-43">
                Organizar planificaciones y documentación docente
              </span>
            </li>
          </ul>
          <p className="text-gray-700 mb-2" data-id="element-44">
            Y cuando finalmente todo está listo… ya perdiste días enteros de
            trabajo.
          </p>
          <p className="text-xl font-bold text-gray-900" data-id="element-45">
            El problema no es la falta de conocimiento.
          </p>
          <p className="text-xl font-bold text-red-600" data-id="element-46">
            El problema es no contar con un sistema académico organizado.
          </p>
        </div>
      </section>

      {/* BEFORE VS AFTER - Image (moved below pain section) */}
      <section className="py-4 px-4 bg-white" data-id="element-47">
        <div className="max-w-3xl mx-auto text-center" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-49">
            🔄 Antes vs Después
          </h2>
          <img src="https://cdn.magicpatterns.com/uploads/gZKk6ZzqTnUVVN8NnB89UT/estres_vs_organizacion.png" alt="Antes vs Después - Estrés vs Organización" className="w-full max-w-2xl mx-auto rounded-xl" data-id="element-50" />
        </div>
      </section>

      {/* SECTION 4 - SOLUTION (green bg) */}
      <section className="py-6 px-4 bg-green-100" data-id="element-51">
        <div className="max-w-3xl mx-auto text-center" data-id="element-52">
          <span className="inline-block bg-green-100 text-green-800 text-sm font-bold px-4 py-1.5 rounded-full mb-2" data-id="element-53">
            ✅ LA SOLUCIÓN
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-54">
            Manual Académico Seguridad e Higiene para Docentes
          </h2>
          <p className="text-lg text-gray-700 mb-4" data-id="element-55">
            Un <strong data-id="element-56">sistema académico completo</strong>, organizado
            progresivamente por año, diseñado para que{' '}
            <strong data-id="element-57">
              tu planificación anual quede resuelta en una tarde y tus clases
              queden listas en minutos.
            </strong>
          </p>

          <div className="bg-white/80 rounded-xl p-4 mb-4" data-id="element-58">
            <div className="space-y-2 text-left max-w-md mx-auto" data-id="element-59">
              <p className="text-lg flex items-center gap-3" data-id="element-60">
                <span className="text-2xl" data-id="element-61">📂</span>
                <span className="text-gray-800" data-id="element-62">Abrís el material</span>
              </p>
              <p className="text-lg flex items-center gap-3" data-id="element-63">
                <span className="text-2xl" data-id="element-64">👆</span>
                <span className="text-gray-800" data-id="element-65">Elegís el año o el módulo</span>
              </p>
              <p className="text-lg flex items-center gap-3" data-id="element-66">
                <span className="text-2xl" data-id="element-67">✏️</span>
                <span className="text-gray-800" data-id="element-68">
                  Lo aplicás directamente en clase
                </span>
              </p>
            </div>
          </div>

          <p className="text-gray-600 mb-3" data-id="element-69">
            Sin improvisar. Sin empezar desde cero. Sin perder semanas
            organizando.
          </p>

          <p className="text-xl font-bold text-gray-900 mb-2" data-id="element-70">
            Imaginá empezar el año con:
          </p>

          <ul className="text-left max-w-md mx-auto space-y-1.5 mb-4" data-id="element-71">
            <li className="flex items-start gap-3" data-id="element-72">
              <span className="text-xl flex-shrink-0" data-id="element-73">✅</span>
              <span className="text-gray-700" data-id="element-74">
                <strong data-id="element-75">Programa anual editable</strong> listo para usar
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-76">
              <span className="text-xl flex-shrink-0" data-id="element-77">✅</span>
              <span className="text-gray-700" data-id="element-78">
                <strong data-id="element-79">Clases estructuradas</strong> desde el primer día
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-80">
              <span className="text-xl flex-shrink-0" data-id="element-81">✅</span>
              <span className="text-gray-700" data-id="element-82">
                <strong data-id="element-83">Casos profesionales reales</strong> preparados para
                trabajar
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-84">
              <span className="text-xl flex-shrink-0" data-id="element-85">✅</span>
              <span className="text-gray-700" data-id="element-86">
                <strong data-id="element-87">Evaluaciones completas</strong> con criterios claros
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-88">
              <span className="text-xl flex-shrink-0" data-id="element-89">✅</span>
              <span className="text-gray-700" data-id="element-90">
                <strong data-id="element-91">Documentación docente lista</strong> para presentar
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-92">
              <span className="text-xl flex-shrink-0" data-id="element-93">✅</span>
              <span className="text-gray-700" data-id="element-94">
                <strong data-id="element-95">Toda tu planificación organizada</strong> en un solo
                sistema
              </span>
            </li>
          </ul>
        </div>
      </section>

      {/* SECTION 5 - CONTENT BREAKDOWN */}
      <section className="py-6 px-4 bg-gray-50" data-id="element-96">
        <div className="max-w-3xl mx-auto text-center" data-id="element-97">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-98">
            📘 ¿Qué incluye exactamente el Manual Académico?
          </h2>
          <p className="text-xl text-gray-700 font-medium mb-4" data-id="element-99">
            Manual Académico Completo – 1°, 2° y 3° Año
          </p>

          <div className="space-y-3 text-left" data-id="element-100">
            <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100" data-id="element-101">
              <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-102">
                🔹 1° Año – Fundamentos
              </h3>
              <p className="text-gray-600" data-id="element-103">
                Normativa, conceptos preventivos y análisis inicial de riesgos.
              </p>
            </div>
            <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100" data-id="element-104">
              <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-105">
                🔹 2° Año – Evaluación Técnica
              </h3>
              <p className="text-gray-600" data-id="element-106">
                Cálculo de índices, evaluación cualitativa, ergonomía y análisis
                aplicado.
              </p>
            </div>
            <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100" data-id="element-107">
              <h3 className="text-xl font-bold text-gray-900 mb-1" data-id="element-108">
                🔹 3° Año – Integración Profesional
              </h3>
              <p className="text-gray-600" data-id="element-109">
                Matrices de riesgos, auditorías simuladas, investigación de
                accidentes y proyectos integradores.
              </p>
            </div>
          </div>

          <p className="text-lg text-gray-700 mt-4 mb-4" data-id="element-110">
            Todo organizado progresivamente y alineado con la práctica
            profesional real.
          </p>

          <CTAButton data-id="element-111">🔒 QUIERO ORGANIZAR MI AÑO ACADÉMICO AHORA</CTAButton>
        </div>
      </section>

      {/* SECTION 7 - BONUSES */}
      <section className="py-6 px-4 bg-white" data-id="element-112">
        <div className="max-w-3xl mx-auto" data-id="element-113">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-1" data-id="element-114">
            🎁 BONOS INCLUIDOS HOY
          </h2>
          <p className="text-lg text-center text-gray-600 mb-4" data-id="element-115">
            (SIN COSTO ADICIONAL)
          </p>

          {/* Bono 1 */}
          <div className="bg-gray-50 rounded-2xl p-4 mb-4 border border-gray-200" data-id="element-116">
            <div className="flex items-center gap-2 mb-3" data-id="element-117">
              <GiftIcon className="w-5 h-5 text-yellow-600" data-id="element-118" />
              <span className="bg-green-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-119">
                🎉 GRATIS POR EL DÍA DE HOY
              </span>
              <span className="text-gray-400 text-sm line-through ml-auto" data-id="element-120">
                Valor: $24,990.00
              </span>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2" data-id="element-121">
              Bono #1 – Sistema de Documentación y Evaluación Docente
              Profesional (Editable)
            </h3>
            <p className="text-gray-700 mb-3 text-sm" data-id="element-122">
              La carpeta docente completa lista para usar:
            </p>
            <ul className="space-y-1.5 mb-2 text-sm" data-id="element-123">
              <li className="flex items-center gap-2 text-gray-600" data-id="element-124">
                <span data-id="element-125">✅</span> Programa anual editable
              </li>
              <li className="flex items-center gap-2 text-gray-600" data-id="element-126">
                <span data-id="element-127">✅</span> Programa analítico por cuatrimestre
              </li>
              <li className="flex items-center gap-2 text-gray-600" data-id="element-128">
                <span data-id="element-129">✅</span> Planificación clase por clase
              </li>
              <li className="flex items-center gap-2 text-gray-600" data-id="element-130">
                <span data-id="element-131">✅</span> Informes académicos
              </li>
              <li className="flex items-center gap-2 text-gray-600" data-id="element-132">
                <span data-id="element-133">✅</span> Rúbricas técnicas profesionales
              </li>
            </ul>
            <img src="https://cdn.magicpatterns.com/uploads/kgoqHxYAM6dMoYb7Yz9w8C/MOCKUP_BONO_1.png" alt="Bono 1 - Sistema de Documentación" className="w-full max-w-[200px] mx-auto aspect-square object-contain" data-id="element-134" />
          </div>

          {/* Bono 2 */}
          <div className="bg-gray-50 rounded-2xl p-4 mb-4 border border-gray-200" data-id="element-135">
            <div className="flex items-center gap-2 mb-3" data-id="element-136">
              <GiftIcon className="w-5 h-5 text-yellow-600" data-id="element-137" />
              <span className="bg-green-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-138">
                🎉 GRATIS POR EL DÍA DE HOY
              </span>
              <span className="text-gray-400 text-sm line-through ml-auto" data-id="element-139">
                Valor: $29,990.00
              </span>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2" data-id="element-140">
              Bono #2 – Banco de Casos Profesionales Aplicados (3 Tomos)
            </h3>
            <p className="text-gray-700 mb-3 text-sm" data-id="element-141">
              Más de 150 páginas de casos técnicos simulados:
            </p>
            <ul className="space-y-1.5 mb-2 text-sm" data-id="element-142">
              <li className="flex items-center gap-2 text-gray-600" data-id="element-143">
                <span data-id="element-144">✅</span> Accidentes laborales
              </li>
              <li className="flex items-center gap-2 text-gray-600" data-id="element-145">
                <span data-id="element-146">✅</span> Evaluación de riesgos
              </li>
              <li className="flex items-center gap-2 text-gray-600" data-id="element-147">
                <span data-id="element-148">✅</span> Investigación con árbol de causas
              </li>
              <li className="flex items-center gap-2 text-gray-600" data-id="element-149">
                <span data-id="element-150">✅</span> Auditorías simuladas
              </li>
              <li className="flex items-center gap-2 text-gray-600" data-id="element-151">
                <span data-id="element-152">✅</span> Resoluciones docentes incluidas
              </li>
            </ul>
            <img src="https://cdn.magicpatterns.com/uploads/mhpCqUPp2aePhXAomJ6g9Y/MOCKUP_BONO_2.png" alt="Bono 2 - Banco de Casos Profesionales" className="w-full max-w-[200px] mx-auto aspect-square object-contain" data-id="element-153" />
          </div>

          {/* Bono 3 */}
          <div className="bg-gray-50 rounded-2xl p-4 border border-gray-200" data-id="element-154">
            <div className="flex items-center gap-2 mb-3" data-id="element-155">
              <GiftIcon className="w-5 h-5 text-yellow-600" data-id="element-156" />
              <span className="bg-green-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-157">
                🎉 GRATIS POR EL DÍA DE HOY
              </span>
              <span className="text-gray-400 text-sm line-through ml-auto" data-id="element-158">
                Valor: $24,990.00
              </span>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2" data-id="element-159">
              Bono #3 – Kit de Evaluaciones y Checklists Profesionales
              (Editable)
            </h3>
            <p className="text-gray-700 mb-3 text-sm" data-id="element-160">
              Sistema completo para evaluar con respaldo técnico:
            </p>
            <ul className="space-y-1.5 mb-2 text-sm" data-id="element-161">
              <li className="flex items-center gap-2 text-gray-600" data-id="element-162">
                <span data-id="element-163">✅</span> Exámenes parciales y recuperatorios
              </li>
              <li className="flex items-center gap-2 text-gray-600" data-id="element-164">
                <span data-id="element-165">✅</span> Trabajos prácticos evaluables
              </li>
              <li className="flex items-center gap-2 text-gray-600" data-id="element-166">
                <span data-id="element-167">✅</span> Evaluaciones integradoras
              </li>
              <li className="flex items-center gap-2 text-gray-600" data-id="element-168">
                <span data-id="element-169">✅</span> Checklists técnicos de inspección
              </li>
              <li className="flex items-center gap-2 text-gray-600" data-id="element-170">
                <span data-id="element-171">✅</span> Claves de corrección y puntajes sugeridos
              </li>
            </ul>
            <img src="https://cdn.magicpatterns.com/uploads/xxUSGK9FvftiX83iXGGANn/MOCKUP_BONO_3.png" alt="Bono 3 - Kit de Evaluaciones" className="w-full max-w-[200px] mx-auto aspect-square object-contain" data-id="element-172" />
          </div>
        </div>
      </section>

      {/* SECTION 8 - WHAT YOU RECEIVE + PRICING */}
      <section id="compra" className="py-6 px-4 bg-gray-50" data-id="element-173">
        <div className="max-w-3xl mx-auto" data-id="element-174">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4" data-id="element-175">
            📦 Lo que vas a recibir hoy
          </h2>

          <div className="bg-white rounded-2xl p-5 shadow-lg border border-gray-200 mb-4" data-id="element-176">
            <ul className="space-y-2" data-id="element-177">
              <li className="flex items-center gap-3 text-lg" data-id="element-178">
                <span className="text-xl flex-shrink-0" data-id="element-179">✅</span>
                <span className="text-gray-800" data-id="element-180">
                  Manual Académico 1°, 2° y 3° Año
                </span>
              </li>
              <li className="flex items-center gap-3 text-lg" data-id="element-181">
                <span className="text-xl flex-shrink-0" data-id="element-182">✅</span>
                <span className="text-gray-800" data-id="element-183">
                  Bono #1: Sistema de Documentación Docente
                </span>
              </li>
              <li className="flex items-center gap-3 text-lg" data-id="element-184">
                <span className="text-xl flex-shrink-0" data-id="element-185">✅</span>
                <span className="text-gray-800" data-id="element-186">
                  Bono #2: Banco de Casos Profesionales
                </span>
              </li>
              <li className="flex items-center gap-3 text-lg" data-id="element-187">
                <span className="text-xl flex-shrink-0" data-id="element-188">✅</span>
                <span className="text-gray-800" data-id="element-189">
                  Bono #3: Kit de Evaluaciones Profesionales
                </span>
              </li>
              <li className="flex items-center gap-3 text-lg" data-id="element-190">
                <span className="text-xl flex-shrink-0" data-id="element-191">✅</span>
                <span className="text-gray-800" data-id="element-192">Acceso inmediato</span>
              </li>
              <li className="flex items-center gap-3 text-lg" data-id="element-193">
                <span className="text-xl flex-shrink-0" data-id="element-194">✅</span>
                <span className="text-gray-800" data-id="element-195">Descarga digital</span>
              </li>
              <li className="flex items-center gap-3 text-lg" data-id="element-196">
                <span className="text-xl flex-shrink-0" data-id="element-197">✅</span>
                <span className="text-gray-800" data-id="element-198">Acceso de por vida</span>
              </li>
            </ul>

            {/* Pricing */}
            <div className="mt-4 pt-4 border-t border-gray-200 text-center" data-id="element-199">
              <p className="text-gray-500 text-lg line-through mb-1" data-id="element-200">
                Precio regular: $49,990.00
              </p>
              <p className="text-sm text-green-700 font-semibold mb-2" data-id="element-201">
                🔥 OFERTA ESPECIAL POR TIEMPO LIMITADO
              </p>
              <p className="text-5xl md:text-6xl font-black text-green-600 mb-1" data-id="element-202">
                $19,990<span className="text-2xl" data-id="element-203">.00</span>
              </p>
              <p className="text-gray-500 text-sm" data-id="element-204">
                Ahorrás $30,000 comprando hoy
              </p>
            </div>
          </div>

          <CTAButton mode="checkout" data-id="element-205">👉 SÍ, QUIERO ACCEDER AHORA</CTAButton>
        </div>
      </section>

      {/* SECTION 9 - GUARANTEE */}
      <section className="py-5 px-4 bg-white" data-id="element-206">
        <div className="max-w-2xl mx-auto text-center" data-id="element-207">
          <div className="bg-green-50 rounded-2xl p-5 border-2 border-green-200" data-id="element-208">
            <ShieldCheckIcon className="w-12 h-12 text-green-600 mx-auto mb-2" data-id="element-209" />
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-210">
              Garantía sin riesgo
            </h2>
            <p className="text-lg text-gray-700" data-id="element-211">
              Probalo durante 7 días. Si no te ayuda a organizar tu año
              académico y reducir tu carga de planificación, te devolvemos el
              100% del dinero.
            </p>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <TestimonialSection data-id="element-212" />

      {/* SECTION 11 - FINAL CTA */}
      <section className="py-8 px-4 bg-gray-900" data-id="element-213">
        <div className="max-w-3xl mx-auto text-center" data-id="element-214">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-215">
            Enseñar Seguridad e Higiene puede ser mucho más simple
          </h2>
          <p className="text-xl text-gray-300 mb-4" data-id="element-216">
            No necesitás más material suelto. Necesitás un sistema académico
            completo que sostenga todo el año.
          </p>
          <CTAButton className="mb-2" data-id="element-217">
            👉 Accedé ahora al Manual Académico Seguridad e Higiene para
            Docentes
          </CTAButton>
          <p className="text-gray-400 mt-3" data-id="element-218">
            Y empezá el próximo ciclo lectivo con toda tu planificación resuelta
            desde el primer día.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-4 px-4 bg-gray-950 text-center" data-id="element-219">
        <p className="text-gray-500 text-sm" data-id="element-220">
          © 2026 Manual Académico Seguridad e Higiene. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}